module.exports = __webpack_public_path__ + "static/media/63.03f93d88.jpg";